import React, { useContext } from 'react'
import GlobalContext from '../../store/global-context'
import './Home.css'
import { LoadingComponent } from 'usbc-web-react-library'
import OrderList from '../Orders/OrderList/OrderList';
import WelcomeMessage from './WelcomeMessage/WelcomeMessage';


function Home() {
    const globalCtx = useContext(GlobalContext);

    return (
        <div className="row g-1 gy-3 pt-0 default-page">
{/*             <LoadingComponent 
                isLoading={() => true} 
                description={"My Content is Loading..."}>
            </LoadingComponent> */}

            <WelcomeMessage />
            <OrderList />
        </div >
    )
}

export default Home